import React, { useState } from 'react';
import { Box, Grid } from '@material-ui/core';
import CollapsableCard from 'src/common/refactoredComponents/collapsableCard/CollapsableCard.jsx';
import edit from 'src/assets/images/Edit.svg';
import CustomLabel from 'src/pages/reportUsage/common/customLabel/CustomLabel';
import TextWithClicks from 'src/pages/reportUsage/common/textWithClicks/TextWithClicks';
import { sizes } from 'src/styles/Media.styled';
import { makeStyles } from '@material-ui/core/styles';
import { LineSeparator } from 'src/pages/reportUsage/review/components/itemsToBeBilled/ItemsToBeBilled.styled';
import {
    StyledTextDiv,
    ExpandCollapseIcon,
} from 'src/pages/reportUsage/utils/reportUsage.styled';
import {
    calculateDiscountPercentage,
    priceFormatObj,
} from 'src/pages/reportUsage/utils/eventHandlerUtil';
import PriceOverrideAndSignature from '../priceOverrideAndSignature';
import { getPriceInNumberDataType } from 'src/pages/reportUsage/utils/dataModificaionUtil';
import DiscountedPriceTemplate from 'src/pages/reportUsage/common/DiscountedPriceTemplate';
import { isIpad, setCurrencyFormat } from 'src/utils/util';
import SummaryContainer from 'src/pages/reportUsage/review/components/itemsToBeBilled/SummaryContent';
import {
    getTotalExtendedPriceOfNonTissueItems,
    getTotalExtendedPriceOfTissueItems,
} from '../../view/reviewUtil';
import PoInfoView from 'src/pages/reportUsage/record/components/reportPayment/PoInfoView';
import collapseIcon from 'src/assets/images/SmallDownArrow.svg';
import { BundleItemContainer } from './ItemsToBeBilled';
import Summary from 'src/common/components/summary';
import { useSelector } from 'react-redux';
import {
    ReplenGrid,
    ReplenTitle,
    ReplenishGridContainer,
} from 'src/pages/equity/components/submit/ReviewSubmitBody.styled';
import { useTranslation } from 'react-i18next';
import { useAdjQtyLabel } from 'src/common/hooks/useAdjQtyLabel';

export const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
    },
    paper: {
        padding: theme.spacing(2),
        // margin: 'auto',
        // maxWidth: 500,
    },
    image: {
        width: 128,
        height: 128,
    },
    img: {
        margin: 'auto',
        display: 'block',
        maxWidth: '100%',
        maxHeight: '100%',
    },
    gridPadBottom: {
        paddingBottom: 8,
    },
}));

const ItemsToBeBilled = ({
    billedItems,
    navigateToSpecifiedScreen,
    priceOverrideReason,
    signatureDetails,
    totalBilledItemsPrice,
    billedNonTissueItemsQty,
    billedTissueItemsQty,
    bundleExpandCollapseIconClickHandler,
    poTitle,
    handlePOTitle,
    handleSumTotal,
    displayPrice,
}) => {
    const { t } = useTranslation();
    const adjQtyLabel = useAdjQtyLabel();
    const [expandedCard, setExpandedCard] = useState({
        itemsToBeBilled: true,
        pricingNotesCard: true,
    });
    const winWidth = window.innerWidth;
    const myCaseResourceType = useSelector(
        (state) => state.reportUsageRootReducer.myCaseResourceType
    );
    const pricingNotes = useSelector(
        (state) => state.reportUsageRootReducer.pricingNotes
    );
    const classes = useStyles();
    const { itemsToBeBilled, pricingNotesCard } = expandedCard;
    const toggleCard = (name, value) => {
        setExpandedCard({
            ...expandedCard,
            [name]: value,
        });
    };
    const mediaSizes = {
        titleArea: 6,
        buttonnsArea: 6,
        xs: 3,
        lg: 2,
    };
    const iPad = isIpad();
    const textAlign = iPad ? 'center' : 'end';

    const usageOrderSubmission = useSelector(
        (state) => state.reportUsageRootReducer.usageOrderSubmission
    );

    const isSubmitClicked = useSelector(
        (state) => state.reportUsageRootReducer.isSubmitClicked
    );

    const orderStatus = useSelector(
        (state) => state.reportUsageRootReducer.orderStatus
    );
    const restrictReviewScreen = useSelector(
        (state) => state.reportUsageRootReducer.restrictReviewScreen
    );

    const isUsagedSubmittedSuccessfully =
        (usageOrderSubmission && usageOrderSubmission.statusCode === '200') ||
        (Object.keys(orderStatus).length > 0 &&
            orderStatus.status &&
            orderStatus.status.includes('Usage Order Submitted Successfully'));

    return (
        <>
            <CollapsableCard id="reportUsage-itemsToBeBilledMobile-itemsToBeBilled-itemsToBeBilled"
                title={`${t(
                    'consignmentBilling.submit.itemsToBeBilled'
                )} (${setCurrencyFormat(totalBilledItemsPrice)})`}
                onClick={() => toggleCard('itemsToBeBilled', !itemsToBeBilled)}
                isExpanded={itemsToBeBilled}
                editButton={
                    isUsagedSubmittedSuccessfully ||
                    isSubmitClicked ||
                    !restrictReviewScreen
                        ? null
                        : edit
                }
                editPage={() => navigateToSpecifiedScreen('Record')}

                // padding={'12px'}
            >
                {itemsToBeBilled && (
                    <>
                        {(priceOverrideReason || signatureDetails) && (
                            <PriceOverrideAndSignature
                                priceOverrideReason={priceOverrideReason}
                                signatureDetails={signatureDetails}
                                pricingNotes={pricingNotes}
                            />
                        )}
                        {billedItems &&
                            billedItems.map((item, index) => (
                                <Box
                                    className={classes.paper}
                                    my={1}
                                    bgcolor={'#ffffff'}
                                    boxShadow={2}
                                    borderRadius={6}
                                    key={item.productCFN + '' + index}
                                >
                                    <Grid lg={12} md={6} sm={6} xs={12}>
                                        <BundleItemContainer>
                                            <TextWithClicks
                                                classes={classes}
                                                media={mediaSizes}
                                                leftTitle={item.productCFN}
                                                // typeNonTissue={
                                                //     item.salesOrg === 'S002'
                                                //         ? 'NT'
                                                //         : item.salesOrg ===
                                                //               'S030' && 'T'
                                                // }
                                                typeNonTissue={
                                                    !item.isBundleItem &&
                                                    !item.isBundleHeader &&
                                                    (item.salesOrg === 'S002'
                                                        ? 'NT'
                                                        : item.salesOrg ===
                                                          'S030'
                                                        ? 'T'
                                                        : undefined)
                                                }
                                                typeEA={
                                                    !item.isBundleItem &&
                                                    !item.isBundleHeader &&
                                                    item.uom
                                                }
                                                typeBundle={
                                                    item.isBundleItem &&
                                                    'BUNDLE'
                                                }
                                                justifyContentVal={'flex-end'}
                                            />
                                            {(item.isBundleItem ||
                                                item.isBundleHeader) &&
                                                Object.prototype.hasOwnProperty.call(
                                                    item,
                                                    'bundleItem'
                                                ) && (
                                                    // item.hasOwnProperty('bundleItem')
                                                    <ExpandCollapseIcon
                                                        id={`expandCollapseIcon-${item.productCFN}-${index}`}
                                                        src={collapseIcon}
                                                        alt="down-arrow"
                                                        isExpanded={
                                                            item.isBundleExpanded
                                                        }
                                                        width="20px"
                                                        height="20px"
                                                        onClick={(e) =>
                                                            bundleExpandCollapseIconClickHandler(
                                                                e,
                                                                item,
                                                                index
                                                            )
                                                        }
                                                    />
                                                )}
                                        </BundleItemContainer>
                                        <CustomLabel
                                            fSize={'12px !important'}
                                            paddingRight={'4rem!important'}
                                            color={'#140F4B'}
                                            label={item.description}
                                            opacity={0.7}
                                        />
                                    </Grid>
                                    <Grid lg={12} md={6} sm={6} xs={12}>
                                        <div
                                            style={{
                                                display: 'flex',
                                                justifyContent: 'space-between',
                                                padding: '8px 0 0 0',
                                            }}
                                        >
                                            {(item.lotSerialNumber ||
                                                item.isBundleItem ||
                                                item.isBundleHeader) && (
                                                <CustomLabel
                                                    fSize={'12px !important'}
                                                    paddingRight={
                                                        '1rem!important'
                                                    }
                                                    color={'#140F4B'}
                                                    label={`${t(
                                                        'consignmentReturn.submit.lotSerial'
                                                    )} ${
                                                        item.isBundleItem ||
                                                        item.isBundleHeader
                                                            ? t(
                                                                  'reportUsage.itemList.lotSerialInputPlaceHolder.notApplicable'
                                                              )
                                                            : item.lotSerialNumber
                                                    }`}
                                                />
                                            )}
                                            <CustomLabel
                                                fSize={'12px !important'}
                                                color={'#E5047E'}
                                                fWeight={'bold'}
                                                label={
                                                    item.overrideUnitPrice
                                                        ? `${calculateDiscountPercentage(
                                                              item.unitPrice,
                                                              item.overrideUnitPrice
                                                          )}${t(
                                                              'reportUsage.review.itemsToBeBilled.ItemsToBeBilled.discount'
                                                          )}`
                                                        : ''
                                                }
                                            />
                                        </div>
                                    </Grid>
                                    <LineSeparator />
                                    <Grid lg={12} md={6} sm={6} xs={12}>
                                        <div
                                            style={{
                                                display: 'flex',
                                                justifyContent: 'space-between',
                                            }}
                                        >
                                            <div style={{ paddingTop: '10px' }}>
                                                <Grid
                                                    item
                                                    xs={1}
                                                    lg={1}
                                                    md={1}
                                                    spacing={1}
                                                    alignItems={'flex-start'}
                                                    justifyContent={
                                                        window.innerWidth >=
                                                        sizes.mediumDevice
                                                            ? 'space-between'
                                                            : 'flex-end'
                                                    }
                                                >
                                                    <CustomLabel
                                                        fSize={
                                                            '12px !important'
                                                        }
                                                        color={'#202124'}
                                                        fWeight={'bold'}
                                                        paddingRight={
                                                            '1rem!important'
                                                        }
                                                        minWidth={'100px'}
                                                        label={
                                                            (item.isBundleItem ||
                                                                item.isBundleHeader) &&
                                                            item.bundleItem
                                                                ?.length >= 0
                                                                ? `${t(
                                                                      'reportUsage.record.priceOverride.AccountOwnedList.index.used'
                                                                  )} ${
                                                                      item.usedQuantity
                                                                  }`
                                                                : item.usedQuantity
                                                                ? `${t(
                                                                      'reportUsage.review.itemsToBeBilled.ItemsToBeBilled.usedQty'
                                                                  )} ${
                                                                      item.usedQuantity
                                                                  }`
                                                                : item.otherQuantity
                                                                ? `${t(
                                                                      adjQtyLabel('reportUsage.review.itemsToBeBilled.ItemsToBeBilled.otherQty')
                                                                  )} ${
                                                                      item.otherQuantity
                                                                  }`
                                                                : ''
                                                        }
                                                    />
                                                </Grid>
                                            </div>

                                            <div>
                                                <StyledTextDiv
                                                    color={'#202124'}
                                                    fontSize={'13px'}
                                                    textAlign={textAlign}
                                                >
                                                    {t(
                                                        'orders.orderDetails.billingSummary.index.unitPrice'
                                                    )}
                                                </StyledTextDiv>
                                                <DiscountedPriceTemplate
                                                    originalPrice={
                                                        getPriceInNumberDataType(
                                                            item.unitPrice
                                                        ) >= 0 &&
                                                        setCurrencyFormat(
                                                            item.unitPrice
                                                        )
                                                    }
                                                    adjustedPrice={
                                                        item.overrideUnitPrice
                                                    }
                                                    modifiedPrice={
                                                        item.overrideUnitPrice
                                                            ? setCurrencyFormat(
                                                                  item.overrideUnitPrice
                                                              )
                                                            : getPriceInNumberDataType(
                                                                  item.unitPrice
                                                              ) >= 0 &&
                                                              setCurrencyFormat(
                                                                  item.unitPrice
                                                              )
                                                    }
                                                />
                                            </div>

                                            <div>
                                                <StyledTextDiv
                                                    color={'#202124'}
                                                    fontSize={'13px'}
                                                    textAlign={textAlign}
                                                >
                                                    {t(
                                                        'orders.orderDetails.billingSummary.index.extPrice'
                                                    )}
                                                </StyledTextDiv>
                                                <DiscountedPriceTemplate
                                                    originalPrice={
                                                        item.unitPrice &&
                                                        (item.usedQuantity ||
                                                            item.otherQuantity) &&
                                                        setCurrencyFormat(
                                                            getPriceInNumberDataType(
                                                                item.unitPrice
                                                            ) *
                                                                parseInt(
                                                                    item.usedQuantity ||
                                                                        item.otherQuantity
                                                                )
                                                        )
                                                        // (
                                                        //     getPriceInNumberDataType(
                                                        //         item.unitPrice
                                                        //     ) *
                                                        //     parseInt(
                                                        //         item.usedQuantity ||
                                                        //             item.otherQuantity
                                                        //     )
                                                        // ).toLocaleString(
                                                        //     'en-US',
                                                        //     priceFormatObj
                                                        // )
                                                    }
                                                    adjustedPrice={
                                                        item.overrideUnitPrice
                                                    }
                                                    modifiedPrice={
                                                        item.overrideUnitPrice &&
                                                        (item.usedQuantity ||
                                                            item.otherQuantity)
                                                            ? setCurrencyFormat(
                                                                  item.overrideUnitPrice *
                                                                      parseInt(
                                                                          item.usedQuantity ||
                                                                              item.otherQuantity
                                                                      )
                                                              )
                                                            : item.unitPrice &&
                                                              (item.usedQuantity ||
                                                                  item.otherQuantity) &&
                                                              setCurrencyFormat(
                                                                  getPriceInNumberDataType(
                                                                      item.unitPrice
                                                                  ) *
                                                                      parseInt(
                                                                          item.usedQuantity ||
                                                                              item.otherQuantity
                                                                      )
                                                              )
                                                        //   (
                                                        //       getPriceInNumberDataType(
                                                        //           item.unitPrice
                                                        //       ) *
                                                        //       parseInt(
                                                        //           item.usedQuantity ||
                                                        //               item.otherQuantity
                                                        //       )
                                                        //   ).toLocaleString(
                                                        //       'en-US',
                                                        //       priceFormatObj
                                                        //   )
                                                    }
                                                />
                                            </div>
                                        </div>
                                        {item?.payment?.poAttachment ? (
                                            item.payment.poAttachment
                                                ?.split(',')
                                                .map((ele) => (
                                                    <PoInfoView
                                                        key={ele}
                                                        fileName={ele}
                                                        item={item}
                                                        reviewPage
                                                    />
                                                ))
                                        ) : (
                                            <PoInfoView
                                                item={item}
                                                reviewPage
                                            />
                                        )}
                                    </Grid>
                                    {item.isBundleExpanded &&
                                        item.bundleItem?.length > 0 &&
                                        item.bundleItem.map((child) => (
                                            <Box
                                                className={classes.paper}
                                                my={1}
                                                bgcolor={'#ffffff'}
                                                boxShadow={2}
                                                borderRadius={6}
                                                key={child.productCFN}
                                            >
                                                <Grid
                                                    lg={12}
                                                    md={6}
                                                    sm={6}
                                                    xs={12}
                                                >
                                                    <TextWithClicks
                                                        classes={classes}
                                                        media={mediaSizes}
                                                        leftTitle={
                                                            child.productCFN
                                                        }
                                                        // typeNonTissue={
                                                        //     child.salesOrg ===
                                                        //     'S002'
                                                        //         ? 'NT'
                                                        //         : child.salesOrg ===
                                                        //               'S030' &&
                                                        //           'T'
                                                        // }
                                                        typeNonTissue={
                                                            !child.isBundleItem &&
                                                            !child.isBundleHeader &&
                                                            (child.salesOrg ===
                                                            'S002'
                                                                ? 'NT'
                                                                : child.salesOrg ===
                                                                  'S030'
                                                                ? 'T'
                                                                : undefined)
                                                        }
                                                        typeEA={
                                                            !child.isBundleItem &&
                                                            !child.isBundleHeader &&
                                                            child.uom
                                                        }
                                                        typeBundle={
                                                            (child.isBundleItem ||
                                                                child.isBundleHeader) &&
                                                            'BUNDLE'
                                                        }
                                                        justifyContentVal={
                                                            'flex-end'
                                                        }
                                                    />
                                                    <CustomLabel
                                                        fSize={
                                                            '12px !important'
                                                        }
                                                        paddingRight={
                                                            '4rem!important'
                                                        }
                                                        color={'#140F4B'}
                                                        label={
                                                            child.description
                                                        }
                                                        opacity={0.7}
                                                    />
                                                </Grid>
                                                <Grid
                                                    lg={12}
                                                    md={6}
                                                    sm={6}
                                                    xs={12}
                                                >
                                                    <div
                                                        style={{
                                                            display: 'flex',
                                                            justifyContent:
                                                                'space-between',
                                                            padding:
                                                                '8px 0 0 0',
                                                        }}
                                                    >
                                                        {child.lotSerialNumber && (
                                                            <CustomLabel
                                                                fSize={
                                                                    '12px !important'
                                                                }
                                                                paddingRight={
                                                                    '1rem!important'
                                                                }
                                                                color={
                                                                    '#140F4B'
                                                                }
                                                                label={`${t(
                                                                    'reportUsage.review.itemsToBeBilled.ItemsToBeBilled.lotSerial'
                                                                )} ${
                                                                    child.lotSerialNumber
                                                                }`}
                                                            />
                                                        )}
                                                    </div>
                                                </Grid>
                                                {/* <Grid
                                                    lg={12}
                                                    md={6}
                                                    sm={6}
                                                    xs={12}
                                                >
                                                    {item.payment
                                                        ?.poAttachment ? (
                                                        item.payment.poAttachment
                                                            ?.split(',')
                                                            .map((ele) => (
                                                                <PoInfoView
                                                                    key={ele}
                                                                    fileName={
                                                                        ele
                                                                    }
                                                                    item={item}
                                                                    reviewPage
                                                                />
                                                            ))
                                                    ) : (
                                                        <PoInfoView
                                                            item={item}
                                                            reviewPage
                                                        />
                                                    )}
                                                </Grid> */}
                                            </Box>
                                        ))}
                                </Box>
                            ))}

                        {poTitle?.length > 0 &&
                        myCaseResourceType === 'reportPayment' ? (
                            <Summary
                                isFromReportPaymentScreen={true}
                                isLegacyMobile={true}
                                margin={
                                    winWidth <= sizes.mobileDevice
                                        ? '0px 24px 4px 19px'
                                        : '0px 33px 4px 19px'
                                }
                                mbHeaderFontSize={'16px'}
                                poTitle={poTitle}
                                handlePOTitle={handlePOTitle}
                                handleSumTotal={handleSumTotal}
                                displayPrice={displayPrice}
                            />
                        ) : (
                            <SummaryContainer
                                nonTissueSummary={{
                                    qty: billedNonTissueItemsQty,
                                    orignalAmt:
                                        getTotalExtendedPriceOfNonTissueItems(
                                            billedItems,
                                            true
                                        ),
                                    discountAmt:
                                        getTotalExtendedPriceOfNonTissueItems(
                                            billedItems,
                                            false
                                        ),
                                }}
                                tissueSummary={{
                                    qty: billedTissueItemsQty,
                                    orignalAmt:
                                        getTotalExtendedPriceOfTissueItems(
                                            billedItems,
                                            true
                                        ),
                                    discountAmt:
                                        getTotalExtendedPriceOfTissueItems(
                                            billedItems,
                                            false
                                        ),
                                }}
                            />
                        )}
                        {/* {pricingNotes.length > 0 && (
                            <ReplenishGridContainer
                                container
                                justifyContent={'space-between'}
                                direction="row"
                                paddingBottom={!pricingNotesCard ? '0px' : '27px'}
                            >
                                <ReplenGrid
                                    item
                                    xs={12}
                                    sm={12}
                                    md={12}
                                    lg={12}
                                    xl={12}
                                    mobile={12}
                                >
                                    <ReplenTitle>
                                        Pricing Notes
                                        <ExpandCollapseIcon
                                            src={collapseIcon}
                                            alt="down-arrow"
                                            isExpanded={pricingNotesCard}
                                            width="28px"
                                            height="28px"
                                            onClick={() =>
                                                toggleCard(
                                                    'pricingNotes',
                                                    !pricingNotesCard
                                                )
                                            }
                                        />
                                    </ReplenTitle>
                                </ReplenGrid>
                                {pricingNotes ? (
                                    <ReplenGrid
                                        item
                                        xs={12}
                                        sm={12}
                                        md={12}
                                        lg={12}
                                        xl={12}
                                        mobile={12}
                                    >
                                        <div
                                            style={{
                                                whiteSpace: 'pre-wrap',
                                                //marginLeft: '17px',
                                                fontSize: '16px',
                                                fontFamily:
                                                    'AvenirNextWorld Regular',
                                                color: '#202124',
                                            }}
                                        >
                                            {pricingNotes}
                                        </div>
                                    </ReplenGrid>
                                ) : null}
                            </ReplenishGridContainer>
                        )} */}
                    </>
                )}
            </CollapsableCard>
        </>
    );
};

export default ItemsToBeBilled;
